export default function({ state, input }) {
  state.set('client.user', input.result)
  state.set('client.currentUser', input.result)
}



// WEBPACK FOOTER //
// ./src/modules/login/actions/setUser.js